module.exports = __webpack_public_path__ + "42297c69933070bcd6e58c7da1104c61.png";